import {
  GroupReducer
} from './groupsSlice';

const groups = (state: GroupReducer) => state.groups;

export const groupsSelectors = {
  groups,
};
